import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Website} from "./website";
import {WebsiteService} from '../website.service';
import {filter, first, switchMap} from "rxjs/operators";
import * as fromStore from "../../store";
import {Store} from "@ngrx/store";

@Injectable()
export class WebsiteSettingsResolver implements Resolve<any | null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _websiteService: WebsiteService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = parseInt(route.params['id'], 10);

      this._store.select(fromStore.getWebsitesLoaded)
        .pipe(
          filter((loaded: Boolean) => !!loaded),
          switchMap(() => this._store.select(fromStore.getWebsite(websiteId))),
          first()
        )
        .subscribe((website: Website) => {
          if (website && website.domain_hash) {
            this._store.select(fromStore.getHostingSettings(website.isNetwork && !website.parentId && website.children && website.children.length ? website.children[0] : website.id))
              .pipe(
                first()
              ).subscribe((settings) => {
                if (settings) {
                  resolve(settings);
                } else {
                  resolve(null);
                }
            });
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
